import { RehearsalScene } from './rehearsal-scene';
import { IRehearsal } from './i-rehearsal.interface';

export class Rehearsal implements IRehearsal{

    public id: number;
    public notes: string;
    public purpose: string;
    public personName: string;
    public performance: PerformanceLite;
    public scenes: RehearsalScene[];

    public create(json: any): Rehearsal {
        if (json == null) {
            throw Error('No json provided');
        }

        const entity = new Rehearsal();
        entity.id = json.id;
        entity.notes = json.notes;
        entity.personName = json.personName;

        entity.performance = new PerformanceLite();
        entity.performance.id = json.performance.id;
        entity.performance.datetime = json.performance.dateTime || null;

        if(json.scenes && Array.isArray(json.scenes) && json.scenes.length > 0) {
            entity.scenes = json.scenes.map(scene => new RehearsalScene().create(scene));
        } else {
            entity.scenes = [];
        }

        entity.purpose = json.purpose;

        return entity;
    }
}

export class PerformanceLite {
    public id: number;
    public datetime?: string;
}
